<template>
  <div class="paymentSuccess">
    <img
      class="paymentSuccess-img"
      src="@/assets/icons/AuthenticationSuccessRegister.svg"
      alt=""
    />
    <p class="paymentSuccess-title">
      {{ $t('paymentSuccess') }}
    </p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'PaymentSuccess'
})
export default class PaymentSuccess extends Vue {}
</script>

<style lang="scss" scoped>
.paymentSuccess {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 280px;
  height: 176px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: $light-grey;
  .paymentSuccess-img {
    margin-bottom: 20px;
    background-color: $light-grey;
  }
  .paymentSuccess-title {
    font-size: $fourteenSize;
    line-height: $fourteenSize;
    font-weight: 600;
    background-color: $light-grey;
  }
}
</style>
